module.exports = __webpack_public_path__ + "static/media/star.a2b86b85.svg";